import { JsonApiQuery } from '@nx-icilalune/data/access';
import { News } from '@nx-icilalune/data/icilalune/types';
import {
  allParagraphIncludes,
  associatedProjectsIncludes,
  projetRelationAttributeEnhancers,
} from './icilalune.queries';
import { ImageMedia } from '@nx-icilalune/drupal-types';

const newsListIncludes = ['thumbnail'];
const promotedNewsFilters = new Map([['promote', '1']]);
export const homeSectionNewsListQuery: JsonApiQuery = {
  queryId: 'homeSectionNewsListQuery',
  type: News.type,
  include: newsListIncludes,
  page: {
    limit: 5,
    offset: 0,
  },
  fields: {
    [News.type]: [
      'list_item_text_preview',
      'title',
      'path',
      'date_only',
      'thumbnail',
      'langcode',
    ],
    [ImageMedia.type]: ['fileRef', 'langcode'],
  },
  sort: [{ field: 'date_only', direction: 'DESC' }],
  relationAttributeEnhancers: ['thumbnail.fileRef'],
  filters: {
    isPublished: '1',
  },
};

export const newsListQuery: JsonApiQuery = {
  queryId: 'newsListQuery',
  type: News.type,
  include: newsListIncludes,
  page: {
    limit: 11,
    offset: 0,
  },
  sort: [{ field: 'date_only', direction: 'DESC' }],
  relationAttributeEnhancers: ['thumbnail.fileRef'],
  paging: true,
  filters: {
    isPublished: '1',
  },
};
const newsDetailIncludes = [
  ...newsListIncludes,
  ...allParagraphIncludes,
  ...associatedProjectsIncludes,
  'media',
];
export const newsDetailQuery: JsonApiQuery = {
  queryId: 'newsDetailQuery',
  type: News.type,
  include: newsDetailIncludes,
  relationAttributeEnhancers: [
    'thumbnail.fileRef',
    ...projetRelationAttributeEnhancers,
  ],
  filters: {
    isPublished: '1',
  },
};
